import request from '../../utils/request';
import { stringify } from 'qs';
import { getSiteIp } from '../../utils/index';

export async function list(params) {
  return request(`/api/blade-interact/lesson/list?${stringify(params)}`);
}

export async function isFull(apiUrl) {
  return request(apiUrl + `/application/count/`);
}

export async function isLock(apiUrl, lessonId) {
  return request(apiUrl + `/application/acount/` + lessonId);
}

export async function authority(params) {
  return request(`/api/blade-interact/lesson/joincourse-permission?${stringify(params)}`);
}

export async function info(params) {
  return request(`/api/blade-interact/lesson/detail?${stringify(params)}`);
}

export async function checkOnline(params) {
  return request(`/api/blade-mbs/stream/check-online?${stringify(params)}`);
}

export async function getPlayUrl(params) {
  const payload = { ...params, siteIp: getSiteIp() };
  return request(`/api/blade-mbs/stream/play-url?${stringify(payload)}`);
}

export async function getHaveClassDateList(params) {
  return request(`/api/blade-interact/lesson/getHaveClassDateList?${stringify(params)}`);
}
